import TypographyNoWrap from './TypographyNoWrap';

export default TypographyNoWrap;
export type { TypographyNoWrapProps } from './TypographyNoWrap';
